export default __webpack_public_path__ + "static/media/NMAH.AC.0433_ref14475.710b7ebc.jpg";